const rating = [
  { key: '5', text: '5 Star', value: '5' },
  { key: '4', text: '4 Star', value: '4' },
  { key: '3', text: '3 Star', value: '3' },
  { key: '2', text: '2 Star', value: '2' },
  { key: '1', text: '1 Star', value: '1' },
];

export { rating };
